import { z } from 'zod';

/**
 * URL state for the labeling page (Browse).
 *
 * The open email lives in the URL so a specific one can be linked to, and so a
 * refresh doesn't dump the reviewer back at the top of an unfiltered list.
 *
 * `mode` is read only to send old links on: the Review, Matches and Claim aging
 * modes moved to the review page (#7656), and those links are in bookmarks and
 * Slack history (`legacyLabelingModeTarget`). It is a loose string on purpose —
 * `validateSearch` rejects the whole route on an enum miss, and the retired
 * `?mode=focus` links must still land somewhere that works.
 */
export const labelingSearchSchema = z.object({
  mode: z.string().optional(),
  filter: z.enum(['unlabeled', 'labeled', 'all']).optional(),
  emailId: z.string().optional(),
  q: z.string().optional(),
});

export type LabelingSearch = z.infer<typeof labelingSearchSchema>;
